var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactUsHeadphones(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.65039 14.6C13.8428 13.7451 17.1197 10.1523 19.1004 6.5C21.698 9.18513 26.0361 11.7555 30.0666 11.7555C32.6237 11.7555 35.0238 11.083 37.1004 9.90629",
    stroke: "#B7CCFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7998 29.9C42.3153 29.6313 44.2998 26.5105 44.2998 22.7003C44.2998 18.8896 42.3153 15.7687 39.7998 15.5V29.9Z",
    fill: "#FF8165"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0499 41.5938C25.2923 41.5938 26.2998 42.6012 26.2998 43.8438C26.2998 45.0863 25.2923 46.0938 24.0499 46.0938C22.8073 46.0938 21.7998 45.0863 21.7998 43.8438C21.7998 42.6012 22.8073 41.5938 24.0499 41.5938Z",
    fill: "#A020FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5343 43.0447C30.389 42.6185 33.2812 41.6199 35.2254 39.6721C37.6401 37.2536 39.5217 33.1529 39.5217 29.4851V17.0061C39.5217 13.3383 37.6401 9.61964 35.2254 7.2015C32.8111 4.78261 29.0978 2.89844 25.4358 2.89844H23.6085C19.9463 2.89844 16.2336 4.78261 13.8193 7.2015C11.4046 9.61964 9.64941 11.8307 9.64941 15.4984",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.98366 29.7214C6.52692 29.456 3.7998 26.3739 3.7998 22.611C3.7998 18.8475 6.52692 15.7654 9.98366 15.5V29.7214Z",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7998 29.7214C43.2566 29.456 45.9837 26.3739 45.9837 22.611C45.9837 18.8475 43.2566 15.7654 39.7998 15.5V29.7214Z",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5019 40.0469C26.1687 40.0469 27.5202 41.4005 27.5202 43.0701C27.5202 44.7395 26.1687 46.0932 24.5019 46.0932C22.8349 46.0932 21.4834 44.7395 21.4834 43.0701C21.4834 41.4005 22.8349 40.0469 24.5019 40.0469Z",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25684 15.8336C13.6812 14.9304 17.4009 12.0853 19.4912 8.22656C22.2325 11.0635 26.0744 12.8283 30.3279 12.8283C33.0264 12.8283 35.5594 12.1178 37.7509 10.8745",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUsHeadphones);
export default __webpack_public_path__ + "static/media/ContactUsHeadphones.cecc4fa8428b0c494c8a9cd06fa985b8.svg";
export { ForwardRef as ReactComponent };